var modules_6cfce947 = {"container":"Checkbox_module_container__26eaf90f","checked":"Checkbox_module_checked__26eaf90f","control":"Checkbox_module_control__26eaf90f","disabled":"Checkbox_module_disabled__26eaf90f","read-only":"Checkbox_module_readOnly__26eaf90f","input":"Checkbox_module_input__26eaf90f","label":"Checkbox_module_label__26eaf90f","icon":"Checkbox_module_icon__26eaf90f"};
import "../../../assets/esm/components/Checkbox/src/Checkbox~CVK_VjFl.css";

export { modules_6cfce947 as default };
//# sourceMappingURL=Checkbox.module.less.js.map
